import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
`;

export const Bar = styled.div`
  background: var(--line);
  border-radius: 4px;
  animation: ${pulse} 1.4s ease-in-out infinite;
  flex-shrink: 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: var(--s3);
  height: var(--h-row);
  padding: 0 var(--s4);
  border-bottom: 1px solid var(--line);

  &:last-child {
    border-bottom: none;
  }
`;
